import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ContactService {
    private serverUrl = `${environment.apiUrl}`;

    constructor(private http: HttpClient) { }

    contactUs(formData: FormData): Observable<any> {
        return this.http.post<any>(`${this.serverUrl}/contact`, formData);
    }
}
